module.exports = __webpack_public_path__ + "img/42.d0ef3624.jpg";